import React, { useEffect } from 'react';
import { dispatch, useReframe } from 'nike-re-framejs';

import BetbookNewPost from './BetbookNewPost';
import PopupNg from '@/ui/PopupNg';
import { fetchPostById } from '@/betbook/handlers';
import { postDetail$ } from '@/betbook/subs';

function BetbookEditPost({ postType, postId }) {
    useEffect(() => {
        PopupNg.dispatcher.closeAll();
        dispatch(fetchPostById(postType, postId));
    }, [postType, postId]);

    const { subscribe } = useReframe();
    const post = subscribe(postDetail$);
    return post ? <BetbookNewPost type={postType} post={post} edit /> : null;
}

export default BetbookEditPost;
